<template>
  <div class="EmpEdit">
    <ld-header
      v-show="showHeader && simpleHeader"
      @click-left="onClickLeft"
    >
      <span>新增员工</span>
    </ld-header>
    <div :class="className">
      <mescroll-vue
        ref="mescroll"
        :down="{ use: false }"
      >
        <div class="wrap">
          <van-cell-group>
            <van-cell><h4>基本信息</h4></van-cell>
            <div>
              <div>
                <van-field
                  v-if="!isShowLabel"
                  v-model="detail.empName"
                  required
                  clearable
                  :label="$t('D058','姓名')"
                  placeholder="请输入名字"
                  @blur.prevent="changeBlur"
                  @input="handleInput"
                />
                <van-cell
                  title="姓（拼音）"
                  label="Surname"
                  required

                  v-else
                >
                  <van-field
                    clearable
                    v-model="Pinyin.surname"
                    placeholder="如 HAN"
                    @blur.prevent="changeBlur"
                    @input="SurName"
                    :error-message="errormessage(Pinyin.surname)"
                  />
                </van-cell>
              </div>
              <!--名-->
              <div>
                <span
                  v-if="!isShowLabel"
                />
                <van-cell
                  title="名（拼音）"
                  label="Given name"
                  required
                  clearable

                  v-else
                >
                  <van-field
                    clearable
                    v-model="Pinyin.name"
                    placeholder="如 MEIMEI"
                    @blur.prevent="changeBlur"
                    @input="Sname"
                    :error-message="errormessage(Pinyin.name)"
                  />
                </van-cell>
              </div>
              <van-field
                v-show="showHeader"
                v-model="detail.empNo"
                required
                :label="$t('D052','员工编号')"
                placeholder="请输入员工编号"
                @blur.prevent="changeBlur"
              />
              <van-cell
                :title="$t('D016','性别')"
                title-class="van-field__label"
                required
              >
                <van-radio
                  v-model="detail.sex"
                  slot="right-icon"
                  name="M"
                >
                  <template #icon="props">
                    <div style="display: flex; align-items: center;">
                      <img
                        class="img-icon"
                        :src="props.checked ? activeIcon : inactiveIcon"
                      >
                      <span style="font-size: 14px;margin-left: 5px" :class="props.checked ? 'man-checked':'man'">{{ $t('D018', '男') }}</span>
                    </div>
                  </template>
                </van-radio>
                <van-radio
                  v-model="detail.sex"
                  slot="right-icon"
                  name="F"
                >
                  <template #icon="props">
                    <div style="display: flex; align-items: center;">
                      <img
                        class="img-icon"
                        :src="props.checked ? active1 : active"
                      >
                      <span style="font-size: 14px;margin-left: 5px" :class="props.checked ? 'woman-checked':'woman'">{{ $t('D019', '女') }}</span>
                    </div>
                  </template>
                </van-radio>
              </van-cell>
            </div>
            <van-field
              v-model="detail.phoneNumber"
              type="tel"
              required
              :label="$t('D049','常用手机')"
              placeholder="请填写手机号"
              :error-message="phoneErrMsg"
              @blur.prevent="changeBlur"
            />
          </van-cell-group>

          <van-cell-group>
            <van-cell><h4>职位信息</h4></van-cell>
            <van-field
              :label="$t('D053','所在部门')"
              v-model="detail.parDepts"
              required
              is-link
              @click="toggleDept"
              input-align="left"
              readonly
            />

            <van-field
              v-show="showHeader"
              :label="$t('D054','差标等级')"
              v-model="empRankName"
              is-link
              @click="empRankShow = true"
              input-align="left"
              readonly
            />
            <van-action-sheet
              v-show="showHeader"
              v-model="empRankShow"
              title="请选择差标等级"
              round
              :actions="empRankList"
              @select="empRankSelect"
              close-on-click-action
            />

            <van-cell
              v-show="showHeader"
              :title="$t('D055','员工状态')"
              required
              title-class="van-field__label"
            >
              <van-radio
                v-model="detail.isValid"
                slot="right-icon"
                :name="1"
              >
                {{ $t('D056', '在职') }}
              </van-radio>
              <van-radio
                v-model="detail.isValid"
                slot="right-icon"
                :name="0"
              >
                {{ $t('D057', '离职') }}
              </van-radio>
            </van-cell>
          </van-cell-group>

          <van-cell-group>
            <van-cell><h4>证件信息</h4></van-cell>
            <div class="IdentityInformation">
              <van-field
                readonly
                clickable
                name="picker"
                :value="value"
                :label="$t('D003','证件类型')"
                placeholder="请选择证件类型"
                @click="showPicker = true"
              />
              <van-popup
                v-model="showPicker"
                position="bottom"
              >
                <van-picker
                  show-toolbar
                  :columns="columns"
                  @confirm="onConfirm"
                  @cancel="showPicker = false"
                />
              </van-popup>
              <!--身份证-->
              <div v-if="identityCard">
                <van-field
                  v-model="detail.cardNo"
                  :label="$t('D004','身份证')"
                  placeholder="与证件保持一致"
                  clearable
                  required
                  :error-message="idNumberErrMsg"
                  @blur.prevent="changeBlur"
                />
              </div>
              <!--护照-->
              <div v-if="passport">
                <van-field
                  required
                  v-model="detail.cardNo"
                  :label="$t('D005','护照')"
                  placeholder="与证件保持一致"
                  clearable
                  @blur.prevent="changeBlur"
                />
                <van-field
                  :label="$t('D009','证件有效期')"
                  readonly
                  clickable
                  placeholder="与证件保持一致"
                  @click="dateShowAction('passportPeriod')"
                  :value="detail.passportPeriod"
                />

                <van-field
                  :label="$t('D017','国籍')"
                  v-show="showHeader"
                  v-model="detail.nationName"
                  required
                  is-link
                  @click="$refs.nation.toggle()"
                  input-align="left"
                  placeholder="与证件保持一致"
                  readonly
                />
                <van-field
                  :label="$t('D013','出生日期')"
                  readonly
                  clickable
                  placeholder="与证件保持一致"
                  @click="dateShowAction('born')"
                  :value="detail.born"
                />
              </div>
              <!--台胞证-->
              <div v-if="TaiwanPackageCertificate">
                <van-field
                  required
                  v-model="detail.cardNo"
                  :label="$t('D008','证件号码')"
                  placeholder="与证件保持一致"
                  clearable
                  @focus.prevent="changefocus"
                />
                <van-field
                  :label="$t('D009','证件有效期')"
                  readonly
                  clickable
                  placeholder="与证件保持一致"
                  @click="dateShowAction('otherPeriod')"
                  :value="detail.otherPeriod"
                />
                <van-field
                  v-if="nati"
                  readonly
                  clickable
                  :label="$t('D017','国籍')"
                  :value="detail.nationName"
                  placeholder="与证件保持一致"
                  required
                  @click="$refs.nation.toggle()"
                />
                <van-field
                  :label="$t('D013','出生日期')"
                  readonly
                  clickable
                  placeholder="与证件保持一致"
                  @click="dateShowAction('born')"
                  :value="detail.born"
                />
              </div>
              <!--出生证明-->
              <div v-if="BirthCertificate">
                <van-field
                  required
                  v-model="detail.cardNo"
                  :label="$t('D008','证件号码')"
                  placeholder="与证件保持一致"
                  clearable
                  @focus.prevent="changefocus"
                />
                <van-field
                  :label="$t('D009','证件有效期')"
                  readonly
                  clickable
                  placeholder="与证件保持一致"
                  @click="dateShowAction('otherPeriod')"
                  :value="detail.otherPeriod"
                />
                <van-field
                  :label="$t('D013','出生日期')"
                  readonly
                  clickable
                  placeholder="与证件保持一致"
                  @click="dateShowAction('born')"
                  :value="detail.born"
                />
              </div>
              <!--港澳台-->
              <div v-if="HongKongMacaoAndTaiwan">
                <van-field
                  required
                  v-model="detail.cardNo"
                  :label="$t('D008','证件号码')"
                  placeholder="与证件保持一致"
                  clearable
                  @focus.prevent="changefocus"
                />
                <van-field
                  :label="$t('D009','证件有效期')"
                  readonly
                  clickable
                  placeholder="与证件保持一致"
                  @click="dateShowAction('otherPeriod')"
                  :value="detail.otherPeriod"
                />
                <van-field
                  :label="$t('D013','出生日期')"
                  readonly
                  clickable
                  placeholder="与证件保持一致"
                  @click="dateShowAction('born')"
                  :value="detail.born"
                />
              </div>
            </div>
          </van-cell-group>

          <van-cell-group title="如需完善员工详细资料，请联系管理员进行处理"/>

          <ld-button
            @click="save"
            main3
            size="lg"
          >
            {{ $t('B010', '保存') }}
          </ld-button>
        </div>
      </mescroll-vue>
    </div>


    <ld-nation
      ref="nation"
      @selected="nationSelect"
    />

    <dept-list
      ref="dept"
      @selected="deptSelect"
    />

    <van-popup
      v-model="dateShow"
      position="bottom"
      :close-on-popstate="true"
      style="{ height: '40%' }"
    >
      <van-datetime-picker
        v-model="datepickModel"
        @confirm="datePickerConfirm"
        @cancel="dateShow = false"
        :min-date="minDate"
        type="date"
      />
    </van-popup>
  </div>
</template>

<script>
import {ActionSheet, Button, Cell, CellGroup, DatetimePicker, Field, Form, NavBar, Picker, Popup, Radio} from 'vant'
import ldHeader from 'Common/ldHeader'
import ldButton from 'Common/ldButton'
import {formatDate} from 'Utils/dateUtil'
import {changeBlur, changefocus} from 'Utils/tools'
import {validators} from 'Utils/valid'
import ldNation from 'Components/ldNation'
import deptList from 'Components/ldEmpList/deptList'
import MescrollVue from 'mescroll.js/mescroll.vue'
import {excludeSpecial} from 'Utils/string'
import {getIDcardInfo} from 'Utils/publicFun'
import ToggleSwitch from 'Views/Home/userCenter/CommonInfo/switch.vue'
import tabman from 'Assets/images/user/man.png'
import tabman1 from 'Assets/images/user/man1.png'
import woman from 'Assets/images/user/woman.png'
import woman1 from 'Assets/images/user/woman1.png'

export default {
  name: 'EmpEdit',
  components: {
    [CellGroup.name]: CellGroup,
    [Field.name]: Field,
    [Cell.name]: Cell,
    [ActionSheet.name]: ActionSheet,
    [Radio.name]: Radio,
    [Popup.name]: Popup,
    [DatetimePicker.name]: DatetimePicker,
    [Button.name]: Button,
    [NavBar.name]: NavBar,
    [Picker.name]: Picker,
    [Form.name]: Form,
    ldHeader, ldButton, ldNation,
    deptList,
    MescrollVue,
    ToggleSwitch,
  },
  props: {
    id: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: '编辑员工信息'
    },
    showHeader: {
      type: Boolean,
      default: true
    },
    simpleHeader: {
      type: Boolean,
      default: true
    },
    className: {
      type: String,
      default: 'wrapper'
    },
    cplx: {//产品类型
      type: [String, Number],
      default: '',
    },
  },
  data() {
    return {
      nati: false,
      isShowLabel: false,
      checked: true,
      HongKongMacaoAndTaiwan: false,//港澳台
      BirthCertificate: false,//出生证明
      identityCard: true,//身份证
      TaiwanPackageCertificate: false,//台胞证
      radio: '1',
      activeIcon: tabman1,
      inactiveIcon: tabman,
      active: woman,
      active1: woman1,
      nationId: '',
      nationName: '',
      passport: false,
      IDNumber: true,
      value: '身份证',
      columns: ['身份证', '护照', '台胞证', '回乡证', '户口簿', '出生证明', '海员', '军人', '港澳台通行', '台湾通行证', '外国人永久居留证', '港澳台居民居住证'],
      showPicker: false,
      Pinyin: {
        surname: '',
        name: '',
        Pinyinz: '',
      },
      detail: {
        isValid: 1,
        sex: 'M',
        parDepts: '',
        passportPeriod: '',
        nation: '',
        nationName: '',
        engName: '',//英文姓名
        empName: '',
        cardType: '',//身份类型
      },
      minDate: new Date('1900-01-01'),
      datepickModel: new Date(),
      dateShow: false,
      phoneErrMsg: '',
      idNumberErrMsg: '',
      empRankShow: false,
      empRankName: '',
      empRankList: [{loading: true}],
      currentCheckBorn: ''
    }
  },
  created() {
    if (this.id) {
      this.query()
    } else {
      this.title = '新增员工'
    }
    this.getEmpRank()
    if (this.cplx == '10902') {
      this.onConfirm('护照', 1)
    }
    if (this.value == '身份证') {
      this.detail.nation = '00002'
      this.detail.cardType = 'NI'
    }
  },
  methods: {
    errormessage(val){
      if(val){
        const regex = /^[a-zA-Z]+$/;
        if(!regex.test(val)){
          return "请以英文输入,勿含空格或其他特殊字符"
        }
      }else{
        return ''
      }
    },
    onClickLeft() {
      this.$router.go(-1)
      this.$i18n.set('zh-CN')
    },
    // 证件类型
    //NI=身份证 PP=护照 GA=港澳台通行 TW=台湾通行证 TB=台胞 HX=回乡 HY=海员  HR=户口簿 JR=军人 BC=出生证明 FI=外国人永久居留证 HM=港澳合居民居住证 ID=其他
    onConfirm(value, key) {
      this.value = value
      this.showPicker = false
      if (key == '0') {
        this.identityCard = true//身份证
        this.passport = false//护照
        this.TaiwanPackageCertificate = false//台胞证
        this.HongKongMacaoAndTaiwan = false//港澳台
        this.isShowLabel = false//切换拼音
        this.detail.cardType = 'NI'//身份证
        this.detail.empName = this.detail.empName
        this.detail.cardName = '身份证'
      } else if (key == '1') {
        this.detail.chName = ''
        this.isShowLabel = true//切换拼音
        this.identityCard = false//身份证
        this.passport = true//护照
        this.TaiwanPackageCertificate = false//台胞证
        this.BirthCertificate = false//出生证明
        this.HongKongMacaoAndTaiwan = false//港澳台
        this.detail.cardType = 'PP'//身份证
        this.detail.cardName = '护照'
      } else if (key == '2') {
        this.detail.chName = ''
        this.isShowLabel = true//切换拼音
        this.TaiwanPackageCertificate = true//台胞证
        this.identityCard = false//身份证
        this.passport = false//护照
        this.BirthCertificate = false//出生证明
        this.HongKongMacaoAndTaiwan = false//港澳台
        this.detail.cardType = 'TB'//身份证
        this.detail.cardName = '台胞'
      } else if (key == '3') {
        this.isShowLabel = true//切换拼音
        this.detail.cardType = 'HX'//身份证
        this.detail.cardName = '回乡'
      } else if (key == '4') {
        this.isShowLabel = false//切换拼音
        this.identityCard = true//身份证
        this.passport = false//护照
        this.TaiwanPackageCertificate = false//台胞证
        this.BirthCertificate = false//出生证明
        this.HongKongMacaoAndTaiwan = false//港澳台
        this.detail.chName = this.detail.empName
        this.detail.cardType = 'HR'//身份证
        this.detail.cardName = '户口簿'
      } else if (key == '5') {
        this.isShowLabel = false//切换拼音
        this.BirthCertificate = true//出生证明
        this.identityCard = false//身份证
        this.passport = false//护照
        this.TaiwanPackageCertificate = false//台胞证
        this.HongKongMacaoAndTaiwan = false//港澳台
        this.detail.cardType = 'BC'//身份证
        this.detail.cardName = '出生证明'
      } else if (key == '6') {
        this.detail.chName = ''
        this.isShowLabel = true//切换拼音
        this.TaiwanPackageCertificate = true//台胞证
        this.identityCard = false//身份证
        this.passport = false//护照
        this.BirthCertificate = false//出生证明
        this.HongKongMacaoAndTaiwan = false//港澳台
        this.detail.cardType = 'HY'//身份证
        this.detail.cardName = '海员'
        console.log('海员')
      } else if (key == '7') {
        this.detail.chName = ''
        this.isShowLabel = true//切换拼音
        this.TaiwanPackageCertificate = true//台胞证
        this.identityCard = false//身份证
        this.passport = false//护照
        this.BirthCertificate = false//出生证明
        this.HongKongMacaoAndTaiwan = false//港澳台
        this.detail.cardType = 'JR'//身份证
        this.detail.cardName = '军人'
        console.log('军人')
      } else if (key == '8') {
        this.detail.chName = ''
        this.isShowLabel = true//切换拼音
        this.TaiwanPackageCertificate = true//台胞证
        this.identityCard = false//身份证
        this.passport = false//护照
        this.BirthCertificate = false//出生证明
        this.HongKongMacaoAndTaiwan = false//港澳台
        this.detail.cardType = 'GA'//身份证
        this.detail.cardName = '港澳台通行'
        console.log('港澳台通行')
      } else if (key == '9') {
        this.detail.chName = ''
        this.isShowLabel = true//切换拼音
        this.TaiwanPackageCertificate = true//台胞证
        this.identityCard = false//身份证
        this.passport = false//护照
        this.BirthCertificate = false//出生证明
        this.HongKongMacaoAndTaiwan = false//港澳台
        this.detail.cardType = 'TW'//身份证
        this.detail.cardName = '台湾通行证'
        console.log('台湾通行证')
      } else if (key == '10') {
        this.detail.chName = ''
        this.nati = true
        this.isShowLabel = true//切换拼音
        this.TaiwanPackageCertificate = true//台胞证
        this.identityCard = false//身份证
        this.passport = false//护照
        this.BirthCertificate = false//出生证明
        this.HongKongMacaoAndTaiwan = false//港澳台
        this.detail.cardType = 'FI'//身份证
        this.detail.cardName = '外国人永久居留证'
        console.log('外国人永久居留证')
      } else if (key == '11') {
        this.isShowLabel = true//切换拼音
        this.HongKongMacaoAndTaiwan = false//港澳台
        this.BirthCertificate = false//出生证明
        this.identityCard = false//身份证
        this.passport = false//护照
        this.TaiwanPackageCertificate = true//台胞证
        this.detail.cardType = 'HM'//身份证
        this.detail.cardName = '港澳合居民居住证'
      }
    },
    // 输入的信息自动转化
    handleInput(event) {
      let pinyin = require('js-pinyin')
      pinyin.setOptions({checkPolyphone: false, charCase: 0})
      const lastName = pinyin.getFullChars(event.substring(0, 1)) // 取姓
      const firstName = pinyin.getFullChars(event.substring(1)) // 取名
      this.Pinyin.surname = lastName
      this.Pinyin.name = firstName
      this.Pinyin.Pinyinz = this.detail.empName
      this.detail.empName = event || ' '
      this.detail.engName = this.Pinyin.surname + '/' + this.Pinyin.name
    },
    SurName(event) {
      // this.Pinyin.surname = event.replace(/[^a-zA-Z]/g, '')
      this.Pinyin.surname = this.Pinyin.surname.toUpperCase()
    },
    Sname(event) {
      // this.Pinyin.name = event.replace(/[^a-zA-Z]/g, '')
      this.Pinyin.name = this.Pinyin.name.toUpperCase()
      this.detail.engName = this.Pinyin.surname + '/' + this.Pinyin.name
      this.detail.empName = this.Pinyin.surname + '/' + this.Pinyin.name
    },
    changeBlur,
    changefocus,
    async query() {
      let res = await this.$api['emp/vipEmpFindDetail']({
        empId: this.id
      })
      this.detail = res.data
      this.datepickModel = new Date(this.detail.born)
      this.getEmpRank()
    },
    getEmpRank() {
      //获取差标等级
      this.$api['common/vipJcsjbGetList']({lb: 11701}).then(res => {
        let emp = res.data || []
        if (res.data) {
          emp.forEach(rank => {
            rank.name = rank.svalue
          })
          this.empRankSelect(emp.find(rank => rank.sn == this.detail.empRank))
          this.empRankList = emp
        }
      })
    },
    empRankSelect(rank = {}) {
      this.detail.empRank = rank.sn
      this.empRankName = rank.svalue
    },
    //打开部门
    toggleDept() {
      this.$refs.dept.toggle()
    },
    deptSelect(info) {
      this.detail.deptId = info.id
      this.detail.parDepts = info.vipdeptName
      this.toggleDept()
    },
    nationSelect(nation) {
      this.$set(this.detail, 'nation', nation.id)
      this.$set(this.detail, 'nationName', nation.cName)
    },
    dateShowAction(row) {
      if (row == 'born') {
        this.currentCheckBorn = row
        this.currentCheckBorn = row
        this.datepickModel = this.detail[this.currentCheckBorn]
          ? new Date(this.detail[this.currentCheckBorn])
          : new Date()
        this.dateShow = true
      } else {
        this.currentCheckBorn = 'otherPeriod'
        this.currentCheckBorn = row
        this.datepickModel = this.detail[this.currentCheckBorn]
          ? new Date(this.detail[this.currentCheckBorn])
          : new Date()
        this.dateShow = true
      }

    },
    datePickerConfirm(date) {
      if (this.currentCheckBorn == 'otherPeriod') {
        this.detail[this.currentCheckBorn] = formatDate(date).date
        this.detail.passportPeriod = this.detail[this.currentCheckBorn]
        this.detail.otherPeriod = this.detail[this.currentCheckBorn]
        this.dateShow = false
        const ageCategory = calculateAgeCategory(formatDate(date).date)
      } else {
        this.detail[this.currentCheckBorn] = formatDate(date).date
        this.dateShow = false
        const ageCategory = calculateAgeCategory(formatDate(date).date)
        if (ageCategory == 1) {
          this.detail.psgType = 1
        } else if (ageCategory == 2) {
          this.detail.psgType = 2
        } else if (ageCategory == 3) {
          this.detail.psgType = 3
        }
      }
    },
    // 保存员工信息
    save() {
      console.log('this', this.detail, this)
      let obj = {}
      if (this.showHeader === true) {
        obj = {
          empNo: '员工编号不能为空',
          deptId: '请选择部门',
          phoneNumber: '手机号不能为空'
        }
      } else {
        obj = {
          deptId: '请选择部门',
          phoneNumber: '手机号不能为空'
        }
      }
      for (let key in obj) {
        let validtor = validators['is-string'](this.detail[key])
        if (!validtor.valid) {
          this.$validErrorTips(obj[key])
          return false
        }
      }
      if (!this.detail.cardNo && !this.detail.passport && !this.detail.cardNo) {
        this.$validErrorTips('证件号码不能为空')
        return false
      }
      if (this.detail.cardType == "NI") {//身份证检验
        if (!validators['is-idCard'](this.detail.cardNo).valid) {
          this.$toast('请输入有效身份证信息')
          return
        }
        if (this.detail.empName) {
          let letters = /[a-zA-Z]/.test(this.detail.empName);
          if (letters) {
            this.$toast('身份证姓名不能包含字母')
            return
          }
        }
      }
      //姓字是中英文的
      let other=['护照','台胞','回乡','户口簿','出生证明','海员','军人','港澳台通行','港澳合居民居住证']
      if(other.includes(this.detail.cardName)){
        const regex = /^[A-Za-z\\/]+$/;
        console.log("this.detail.empName",this.detail.empName)
        if(!regex.test(this.detail.empName)){
          this.$toast('请录入正确的姓名')
          return
        }
      }
      if (this.detail.passport) {
        if (!this.detail.passportPeriod) {
          this.$validErrorTips('请输入护照有效期')
          return false
        }
      }
      if (this.showHeader === true && this.id) {
        this.vipEmpEditDetail()
      } else if (!this.id) {
        this.vipEmpSaveDetail()
      }
    },
    //简易新增员工
    vipEmpSaveDetail() {
      //判断姓名中是否有点
      if (this.detail.empName.includes('·')) {
        this.detail.empName = this.detail.empName.split('·').join('');
      }
      this.$api['emp/vipEmpSaveDetail'](this.detail).then(() => {
        this.$dialog.alert({message: '新增成功'}).then(() => {
          if (this.showHeader === true && this.id) {
            this.$router.back()
          } else if (this.simpleHeader === false && !this.id) {
            this.$emit('call-back', false)
            this.detail = {
              isValid: 1,
              sex: 'M',
              parDepts: '',
              passportPeriod: '',
              passportDateOfIssue: '',
              phoneNumber: '',
              idNumber: '',
              born: '',
              otherPeriod: '',
              otherDateOfIssue: '',
              passport: '',
              nation: '',
              nationName: '',
              deptId: '',
              empRank: '',
              empNo: '',
              engName: '',
              empName: '',
              cardType: '',
              cardNo: '',
              cardName: '',
            }
            this.empRankName = ''
          } else if (!this.id) {
            this.$router.back()
          }
        })
      })
    },
    //
    vipEmpEditDetail() {
      this.$api['emp/vipEmpEditDetail'](this.detail).then((res) => {
        this.$dialog({message: '编辑成功'}).then(() => {
          this.$router.go(-1)
        })
      })
    }
  },
  watch: {
    'detail.phoneNumber': function (val) {
      this.detail.phoneNumber = excludeSpecial(val)
      if (!validators.mobile(val).valid) {
        this.phoneErrMsg = validators.mobile(val).msg
      } else {
        this.phoneErrMsg = ''
      }
    },
    'detail.idNumber': function (val) {
      // this.detail.idNumber = excludeSpecial(val)
      if (val && !validators['is-idCard'](val).valid) {
        this.idNumberErrMsg = validators['is-idCard'](val).msg
      } else {
        this.idNumberErrMsg = ''
      }
      if (!this.detail.born && this.detail.cardNo && !this.idNumberErrMsg) {
        this.detail.born = getIDcardInfo(this.detail.cardNo).born
      }
    },

  }
}

function calculateAgeCategory(birthdate) {
  const today = new Date()
  const birthdateArr = birthdate.split('-')
  const birthYear = parseInt(birthdateArr[0])
  const birthMonth = parseInt(birthdateArr[1]) - 1
  const birthDay = parseInt(birthdateArr[2])

  const birthdateObj = new Date(birthYear, birthMonth, birthDay)
  let age = today.getFullYear() - birthdateObj.getFullYear()

  // 检查生日是否已经过了，如果生日还未到，则年龄减一
  const hasPassedBirthday = today.getMonth() > birthdateObj.getMonth() ||
    (today.getMonth() === birthdateObj.getMonth() && today.getDate() >= birthdateObj.getDate())
  if (!hasPassedBirthday) {
    age--
  }
  // 判断年龄类别
  if (age >= 18) {
    return '1'
  } else if (age >= 12) {
    return '1'
  } else if (age >= 1) {
    return '2'
  } else {
    return '3'
  }
}
</script>

<style lang="less" scoped>
.EmpEdit {
  h4 {
    margin: 0;
  }

  .van-cell__title + .van-radio {
    padding-right: 20px;
  }

  .wrap {
    padding: 10px 6px;
  }

  .wrapper {
    height: calc(100vh - 46px);
    overflow: hidden;
  }

  .wrapper1 {
    height: calc(100vh - 100px);
    overflow: hidden;
  }
}

.van-cell__title {
  flex: 0.3;
}

.img-icon {
  height: 20px;
}
.man,.woman {
  color: #c8c8c8;
}
.man-checked {
  color: #007aff;
}
.woman-checked {
  color: #ff1493;
}
</style>

